import {
	ClientIntakeFormContext,
	ClientIntakeMappedClient,
} from '@models/client-intake';
import { Client, ClientType } from '@models/clients';
import { isBusinessClient } from '@globalUtils/client-intake';
import { getFullName } from '@globalUtils/utilities/string';

export function syncContextClientsFromMatterClients(
	currentContext: ClientIntakeFormContext,
	clients: Client[],
): {
	clientsToAdd: ClientIntakeMappedClient[];
	clientsToRemove: ClientIntakeMappedClient[];
} {
	const existingClients = currentContext.clients?.all || [];

	// Map matter clients to ClientIntakeMappedClient format (filter out clients without names)
	const mappedMatterClients: ClientIntakeMappedClient[] = clients
		.map((client) => {
			const name = isBusinessClient(client)
				? client.name
				: getFullName([client.firstName, client.middleNames, client.lastName]);

			if (!name) return null;

			return {
				id: client.id,
				name,
				type: {
					person: client.type === ClientType.PERSON,
					corporation: client.type === ClientType.CORPORATION,
					builder: client.type === ClientType.BUILDER,
				},
			};
		})
		.filter((client): client is ClientIntakeMappedClient => client !== null);

	// Find clients to add: in matter but not in context
	const clientsToAdd = mappedMatterClients.filter(
		(matterClient) =>
			!existingClients.some(
				(existingClient) => existingClient.id === matterClient.id,
			),
	);

	// Find clients to remove: in context but not in matter
	const clientsToRemove = existingClients.filter(
		(existingClient) =>
			!mappedMatterClients.some(
				(matterClient) => matterClient.id === existingClient.id,
			),
	);

	return { clientsToAdd, clientsToRemove };
}
